<template>
  <div>
    <transition name="component-fade" mode="out-in">
      <component v-bind:is="view" v-on:submitted-contact-form="contactFormSubmitted"></component>
    </transition>
  </div>
</template>

<script>
import ContactForm from "./ContactForm.vue";
import ThankYou from "./ThankYou.vue";

export default {
  name: "contactButton",
  data: function () {
    return {
      view: "contactForm",
    };
  },
  methods: {
    contactFormSubmitted: function () {
      this.view = "thankYou";
    },
  },
  components: {
    contactForm: ContactForm,
    thankYou: ThankYou,
  },
};
</script>

<style>
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.sneos-contact {
  padding: 20px;
  background-color: lightblue;
}

.sneos-contact h3 {
  background-color: whitesmoke;
  padding: 20px;
  text-align: center;
}
</style>